





















































































































import gbutton from "./button.vue";
import ripple from "./ripple.vue";
import calendar from "./calendar.vue";
import iconButton from "./iconButtons.vue";
import moveableItem from "./moveableItem.vue";
import calItem from "./calItem.vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { frontendClient } from "../lib/client";
import {SharedJobInfo} from "../lib/httpapi" 

@Component({
    components:{
        ripple,
        calendar,
        iconButton,
        moveableItem,
        calItem
    }
})
export default class Navigation extends Vue {

    @Prop({}) open:boolean;
    @Prop({}) staffAllocated:number;

    sliderPosition:number = 0;
    sliderStyle = null;
    subNavVisible:boolean = false;
    expandedSubNav:boolean = false;
    movedRight:boolean = false;
    previousView:string = null;

    jobItems: SharedJobInfo[] = []

    workerReturns:{
        name:string,
        days:{
            day:number,
            date:Date,
            selected:boolean,
            appointed:boolean,
            pending:boolean,
        }[]
    }[] = [
        {
            name:"No Returns",
            days: []
        }
    ]

    navItems:{
        routes?: string[],
        name?: string,
        icon?: string,
        active?: boolean,
        function?: any,
        isHR?:boolean,
        calendar?:boolean,
        listItems?:{
            name?: string,
            icon?: string,
            active?: boolean
            function?: any,
        }[],
    }[] = [];

    updateCb: any;
    mounted(){
        this.updateCb = (data) => {
            if(!data.availchange) {
                this.updateDetachedJobList();
            }
            if(data.userupdate || data.availchange) {
                this.updateWalkerList();
            }
        };
        frontendClient.wsClient.on("updatecal",this.updateCb);

        window["calendarFocusChanged"] = () => {
            this.updateWalkerList();
        };

        this.determineNav();

        this.updateWalkerList();
        this.updateDetachedJobList();
    }

    beforeDestroy() {
        frontendClient.wsClient.removeListener("updatecal",this.updateCb);

        window["calendarFocusChanged"] = null;
    }

    closeNav(){
        this.$emit('closeNav')
    }

    async updateDetachedJobList() {
        if(frontendClient.userData.rank == "admin"){
            this.jobItems = (await frontendClient.postEx("jobs/list/detached",{})).jobs;
        }
    }

    lastWLUpdateTimer:any;
    isUpdatingWL = false;
    updateWalkerList() {
        if(this.isUpdatingWL) { return; }

        if(this.lastWLUpdateTimer) {
            clearTimeout(this.lastWLUpdateTimer);
        }

        this.lastWLUpdateTimer = setTimeout(() => {
            this.lastWLUpdateTimer = null;
            if(!this.isUpdatingWL) {
                this.isUpdatingWL = true;
                this.updateWalkerListEx().finally(() => {
                    this.isUpdatingWL = false;
                });
            }
        },1000);
    }

    async updateWalkerListEx() {
        if(frontendClient.userData.rank == "admin"){
            let walkerData = (await frontendClient.postEx("walkers/avails",{
                timeOffset: window["getCurrentCalendarDate"] ? window["getCurrentCalendarDate"]().getTime() : Date.now(),
            })).list;
            
            this.workerReturns = [];

            for(let walker of walkerData) {
                let workerRet = {
                    name: walker.fullName,
                    workerID: walker.userID,
                    days: [],
                };
                let shouldPush = false;
                for(let workingDay of walker.dayPreferences) {
                    if(workingDay.canWork){
                        shouldPush = true;
                    }
                    workerRet.days.push({
                        day: workingDay.dayNumber,
                        date: new Date(workingDay.timestamp),
                        selected: workingDay.canWork,
                        appointed: workingDay.isAppointed,
                    });
                }
                if(shouldPush){
                    this.workerReturns.push(workerRet);
                }
            }
            
        }
    }

    expandSubNav(){
        this.expandedSubNav = !this.expandedSubNav;
        this.redirect('admin-calendar');
    }

    assignJobs(){
        this.movedRight = false;
        this.$route.params.walkerappoint = 'false';       
    }

    assignWalkers(){
        this.movedRight = true; 
        this.$route.params.walkerappoint = 'true';        
    }

    determineNav(){
        if(frontendClient.userData.rank == "staff"){
            this.navItems = [
                {
                    routes: ["worker-home"],
                    name: 'Home',
                    icon: 'home',
                    active: true,
                    function: ()=>{this.redirect('worker-home',{title:'alerts'});},
                },
                {
                    routes: ["worker-jobs", "jobView"],
                    name: 'Jobs',
                    icon: 'assignment',
                    active: false,
                    function: ()=>{this.redirect('worker-jobs',{title:null});},
                },
                {
                    routes: ["worker-calendar"],
                    name: 'Calendar',
                    icon: 'date_range',
                    active: false,
                    function: ()=>{this.redirect('worker-calendar');},
                    calendar:true,
                    listItems:[
                        {
                            name:'Days I can work',
                            icon: 'touch_app',
                            active: false,
                            function: ()=>{this.redirect('worker-calendar',{scope:'daySelect'});},
                        },
                        {
                            name:'My calendar',
                            icon: 'save_alt',
                            active: false,
                            function: ()=>{this.redirect('worker-calendar',{scope:'myCalendar'});},
                        },

                    ]
                },
                
                {
                    isHR:true,
                },
                {
                    routes: ["worker-chat"],
                    name: 'Message us',
                    icon: 'chat',
                    active: false,
                    function: ()=>{this.redirect('worker-chat');},
                },
                {
                    routes: ["worker-alerts"],
                    name: 'Alerts',
                    icon: 'notification_important',
                    active: false,
                    function: ()=>{this.redirect('worker-alerts');},
                },
                {
                    isHR:true,
                },
                {
                    routes: ["worker-graphs"],
                    name: 'My account',
                    icon: 'account_circle',
                    active: false,
                    function: ()=>{this.redirect('worker-graphs');},
                },
                {
                    routes: ["worker-updates"],
                    name: 'Extranet updates',
                    icon: 'update',
                    active: false,
                    function: ()=>{this.redirect('worker-updates');},
                }

            ]
        }else if(frontendClient.userData.rank == "admin"){
            this.subNavVisible = true;
            this.navItems = [
                {
                    routes: ["admin-home"],
                    name: 'Home',
                    icon: 'home',
                    active: true,
                    function: ()=>{this.redirect('admin-home',{title:'alerts'});},
                },
                {
                    routes: ["admin-calendar"],
                    name: 'Calendar',
                    icon: 'date_range',
                    active: false,
                    function: ()=>{this.redirect('admin-calendar');},
                    calendar:true,
                },
                {
                    routes: ["admin-jobs", "jobView"],
                    name: 'Jobs',
                    icon: 'assignment',
                    active: false,
                    function: ()=>{this.redirect('admin-jobs',{title:null});},
                }, 
                {
                    isHR:true,
                },
                {
                    routes: ["admin-staff"],
                    name: 'Staff',
                    icon: 'account_circle',
                    active: false,
                    function: ()=>{this.redirect('admin-staff');},
                },     
                {
                    routes: ["admin-clients"],
                    name: 'Clients',
                    icon: 'business_center',
                    active: false,
                    function: ()=>{this.redirect('admin-clients');},
                },             
                {
                    isHR:true,
                },
                {
                    routes: ["admin-chat"],
                    name: 'Messaging',
                    icon: 'question_answer',
                    active: false,
                    function: ()=>{this.redirect('admin-chat');},
                },
                {
                    routes: ["admin-alerts"],
                    name: 'Alerts',
                    icon: 'notification_important',
                    active: false,
                    function: ()=>{this.redirect('admin-alerts');},
                },
                {
                    routes: ["admin-updates"],
                    name: 'Extranet updates',
                    icon: 'update',
                    active: false,
                    function: ()=>{this.redirect('admin-updates');},
                }

            ]
        }
    }

    callItemFunction(func){
        func;
    }

    redirect(route,parameters?){
        
        this.updateSlider()
        setTimeout(() => {
            this.closeNav();
            if(parameters){
                this.$router.replace({ name: route, params: parameters});
            }else{
                this.$router.push({ name: route, params: parameters});
            }
        },100)
    };

    updateSlider(){
        if(this.$route.params.title){
            switch(this.$route.params.title){
                case 'current':
                    this.sliderPosition = 0;
                    break;
                case 'alerts':
                    this.sliderPosition = 0;
                    break;
                case 'complete':
                    this.sliderPosition = 1;
                    break;
                case 'graphs':
                    this.sliderPosition = 1;
                    break;
                case 'updates':
                    this.sliderPosition = 2;
                    break;
                default:
                    this.sliderPosition = 0;
                    break;
            }
        }else if(this.$route.params.scope){
            switch(this.$route.params.scope){
                case 'daySelect':
                    this.sliderPosition = 0;
                    break;
                case 'myCalendar':
                    this.sliderPosition = 1;
                    break;
                default:
                    this.sliderPosition = 0;
                    break;
            }
        }
        
        this.sliderStyle = {
            transform: `translate3d(0,${(this.sliderPosition * 100)}%,0)`,
        }
    }

    
    changeNav(item?){
        if(item){
            item.function();
        }

        for(let i=0; i<this.navItems.length; i++){
            if(this.navItems[i].routes){
                for(let j=0; j<this.navItems[i].routes.length; j++){
                    if(this.navItems[i].routes[j] == this.$route.name){
                        this.navItems[i].active = true;
                        break;
                    }else{
                        this.navItems[i].active = false;
                    }
                }
            }
        }

        this.updateSlider();
    }

    beginAllocation(avail,workerID,workerName){
        if(!avail.selected) return;
        this.$route.params.activeWorkerName = workerName;
        this.$route.params.activeWorkerID = workerID;
        this.$route.params.allocating = `${(avail.date as Date)}`;

        this.refresh();
    }

    @Watch('$route.name')
    updateRoute(to, from, next){
        this.changeNav(false);
    }

    @Watch('$route.params')
    updateParams(to, from, next){
        this.updateSlider();
    }

    @Watch('staffAllocated')
    refresh(){
        this.$forceUpdate();
    }

}

